import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { Query } from '../Query';
import { deepMergeObjects } from '../../utils/object';

export class CollectionTransform extends BaseTransform {
	execute(queryResponse: any[], queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		const response: any[] = [];
		const { fields } = this.options;
		if (queryResponse) {
			for (const queryResponseRow of queryResponse) {
				const row: object = { ...queryResponseRow };
				const workingExecutionOptions = deepMergeObjects(executionOptions, { responseContext: row } as Partial<IExecutionOptions>);
				for (const field of fields) {
					const { key, query } = field;
					if (query) {
						const valueQuery = new Query(query);
						const value = valueQuery.execute(workingExecutionOptions);
						row[key] = value;
					}
				}
				response.push(row);
			}
		}
		return response;
	}
}